export interface IQcEnrollmentData {
  qcName : string,
  qcEmail : string,
  salesChannel : string
}

export const defaultQcEnrollment = {
  qcFirstName : '',
  qcLastName: '',
  qcEmail : '',
  salesChannel : ''
}

export type StepProps = {
  data: IQcEnrollmentData
  updateData: (fieldsToUpdate: Partial<IQcEnrollmentData>) => void
  hasError: boolean
  formik: any
  hasFieldError :boolean
  method:any
}

export type StepCustomerProps = {
  data: IQcEnrollmentData
  updateData: (fieldsToUpdate: Partial<IQcEnrollmentData>) => void
  hasError: boolean
  formik: any
  hasFieldError :boolean
  mobileValidation: (phonenumber: any) => void
  phoneValidProps : any
  method:any
}

// Need to set these when we click on edit
export const editQcEnrollment = {
  qcName : '',
  qcEmail : '',
  salesChannel : ''
}
